// 🔴 MARIO P0 (13/10) — « Base de tarification » d'un produit : la nature (forfait / à la pièce / au m²) est ENFIN visible et éditable.
// Affiché UNIQUEMENT si le tenant déclare un profil chantier (aujourd'hui mario_bat) ET si l'unité est une unité de mesure.
// Valeur vide = « non précisé » = comportement actuel INCHANGÉ (rien n'est écrit). Écrit dans `base_tarifaire` (seule source de décision).
import { profilChantier } from "../../utils/tenantProfile";

export const UNITES_DE_MESURE = ["m²", "ml", "m³"];
export const BASES = [
  { value: "", label: "Non précisé (comportement actuel)" },
  { value: "forfait", label: "Forfait — le prix est celui de la ligne, quelle que soit la surface" },
  { value: "piece", label: "À la pièce — prix × nombre" },
  { value: "mesure", label: "Au m² / au ml — prix × surface ou longueur" },
];

export function baseTarificationVisible(unite) {
  return Boolean(profilChantier()) && UNITES_DE_MESURE.includes(String(unite || ""));
}

// LOT C — une LIGNE de devis : l'unité qui compte est celle de la MESURE relevée (la ligne forfait s'affiche « forfait »), sinon celle de la ligne.
export function uniteDeMesureDeLigne(ligne) {
  return String(ligne?.mesure_releve?.unite || ligne?.unite || "");
}

// « indetermine » (nature non établie au catalogue) se lit « non précisé » dans le sélecteur.
export function baseAffichee(valeur) {
  return ["forfait", "piece", "mesure"].includes(valeur) ? valeur : "";
}

export default function BaseTarificationField({ unite, value, onChange, disabled = false, idSuffix = "", description = null }) {
  if (!baseTarificationVisible(unite)) return null;
  const selectId = `base-tarification-select${idSuffix ? `-${idSuffix}` : ""}`;
  return (
    <div className="space-y-2" data-testid="base-tarification">
      <label className="text-sm text-[var(--oh-text-secondary)]" htmlFor={selectId}>Base de tarification</label>
      <select id={selectId} data-testid="base-tarification-select" value={value || ""} disabled={disabled}
              onChange={(e) => onChange(e.target.value)}
              className="w-full h-9 rounded-lg px-3 text-sm bg-[var(--oh-bg-elevated)] text-[var(--oh-text)] border border-[var(--oh-border)]">
        {BASES.map((b) => <option key={b.value} value={b.value}>{b.label}</option>)}
      </select>
      <p className="text-xs text-[var(--oh-text-muted)]">
        {description || `Dit si le prix de ce produit est un forfait ou un prix par ${unite}. Une dictée de surface en tient compte : forfait ⇒ prix inchangé (surface gardée en information) ; au ${unite} ⇒ surface × prix.`}
      </p>
    </div>
  );
}
